import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell, AreaChart, Area } from 'recharts';
import { Calendar, Download, TrendingUp, TrendingDown, DollarSign, AlertTriangle } from 'lucide-react';
import { StatCard } from '../components/StatCard';
export function Reports() {
  const [dateRange, setDateRange] = useState('last-30');
  const priceTrendData = [{
    name: 'Sem 1',
    suaLoja: 4200,
    mercado: 4100
  }, {
    name: 'Sem 2',
    suaLoja: 4150,
    mercado: 4120
  }, {
    name: 'Sem 3',
    suaLoja: 4100,
    mercado: 4150
  }, {
    name: 'Sem 4',
    suaLoja: 4050,
    mercado: 4180
  }];
  const supplierPerformanceData = [{
    name: 'Samsung',
    score: 92,
    delivery: 95
  }, {
    name: 'Apple',
    score: 88,
    delivery: 90
  }, {
    name: 'LG',
    score: 85,
    delivery: 88
  }, {
    name: 'Sony',
    score: 82,
    delivery: 85
  }, {
    name: 'Dell',
    score: 78,
    delivery: 82
  }];
  const marginData = [{
    name: 'Alta (>20%)',
    value: 35
  }, {
    name: 'Média (10-20%)',
    value: 45
  }, {
    name: 'Baixa (<10%)',
    value: 15
  }, {
    name: 'Negativa',
    value: 5
  }];
  const COLORS = ['#10B981', '#3B82F6', '#F59E0B', '#EF4444'];
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} className="space-y-8" data-id="element-686">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-687">
        <div data-id="element-688">
          <h1 className="text-2xl font-bold text-navy-900" data-id="element-689">
            Relatórios e Analytics
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-690">
            Análise detalhada de performance e competitividade
          </p>
        </div>

        <div className="flex gap-3" data-id="element-691">
          <div className="relative" data-id="element-692">
            <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="appearance-none bg-white border border-slate-200 text-slate-700 py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-navy-900 text-sm shadow-sm" data-id="element-693">
              <option value="last-7" data-id="element-694">Últimos 7 dias</option>
              <option value="last-30" data-id="element-695">Últimos 30 dias</option>
              <option value="last-90" data-id="element-696">Últimos 3 meses</option>
              <option value="ytd" data-id="element-697">Ano atual</option>
            </select>
            <Calendar className="absolute right-3 top-2.5 h-4 w-4 text-slate-400 pointer-events-none" data-id="element-698" />
          </div>

          <button className="flex items-center px-4 py-2 bg-navy-900 text-white rounded-lg text-sm font-medium hover:bg-navy-800 transition-colors shadow-sm" data-id="element-699">
            <Download className="h-4 w-4 mr-2" data-id="element-700" />
            Exportar PDF
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-701">
        <StatCard title="Competitividade Geral" value="94%" icon={TrendingUp} accentColor="green" trend="+2.5%" trendDirection="up" delay={0} data-id="element-702" />
        <StatCard title="Margem Média" value="18.2%" icon={DollarSign} accentColor="navy" trend="+0.8%" trendDirection="up" delay={0.1} data-id="element-703" />
        <StatCard title="Produtos Críticos" value="12" icon={AlertTriangle} accentColor="red" trend="-3" trendDirection="down" delay={0.2} data-id="element-704" />
        <StatCard title="Oportunidades" value="R$ 15k" icon={TrendingDown} accentColor="amber" trend="Potencial mensal" trendDirection="neutral" delay={0.3} data-id="element-705" />
      </div>

      {/* Main Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-706">
        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-707">
          <h3 className="text-lg font-bold text-navy-900 mb-6" data-id="element-708">
            Tendência de Preços vs Mercado
          </h3>
          <div className="h-[300px]" data-id="element-709">
            <ResponsiveContainer width="100%" height="100%" data-id="element-710">
              <AreaChart data={priceTrendData} data-id="element-711">
                <defs data-id="element-712">
                  <linearGradient id="colorSuaLoja" x1="0" y1="0" x2="0" y2="1" data-id="element-713">
                    <stop offset="5%" stopColor="#1B2A4A" stopOpacity={0.1} data-id="element-714" />
                    <stop offset="95%" stopColor="#1B2A4A" stopOpacity={0} data-id="element-715" />
                  </linearGradient>
                  <linearGradient id="colorMercado" x1="0" y1="0" x2="0" y2="1" data-id="element-716">
                    <stop offset="5%" stopColor="#64748b" stopOpacity={0.1} data-id="element-717" />
                    <stop offset="95%" stopColor="#64748b" stopOpacity={0} data-id="element-718" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" vertical={false} data-id="element-719" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} dy={10} data-id="element-720" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} tickFormatter={value => `R$${value}`} data-id="element-721" />
                <Tooltip contentStyle={{
                backgroundColor: '#fff',
                borderRadius: '8px',
                border: '1px solid #e2e8f0'
              }} formatter={(value: number) => [`R$ ${value}`, '']} data-id="element-722" />
                <Legend verticalAlign="top" height={36} data-id="element-723" />
                <Area type="monotone" dataKey="suaLoja" name="Sua Loja" stroke="#1B2A4A" fillOpacity={1} fill="url(#colorSuaLoja)" strokeWidth={3} data-id="element-724" />
                <Area type="monotone" dataKey="mercado" name="Média Mercado" stroke="#64748b" fillOpacity={1} fill="url(#colorMercado)" strokeWidth={2} strokeDasharray="5 5" data-id="element-725" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-726">
          <h3 className="text-lg font-bold text-navy-900 mb-6" data-id="element-727">
            Distribuição de Margem
          </h3>
          <div className="h-[300px] flex items-center justify-center" data-id="element-728">
            <ResponsiveContainer width="100%" height="100%" data-id="element-729">
              <PieChart data-id="element-730">
                <Pie data={marginData} cx="50%" cy="50%" innerRadius={80} outerRadius={110} paddingAngle={5} dataKey="value" data-id="element-731">
                  {marginData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-732" />)}
                </Pie>
                <Tooltip data-id="element-733" />
                <Legend verticalAlign="bottom" height={36} data-id="element-734" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Supplier Performance */}
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-735">
        <div className="flex justify-between items-center mb-6" data-id="element-736">
          <h3 className="text-lg font-bold text-navy-900" data-id="element-737">
            Performance por Fornecedor
          </h3>
          <button className="text-sm text-navy-600 font-medium hover:text-navy-800" data-id="element-738">
            Ver relatório completo
          </button>
        </div>
        <div className="h-[300px]" data-id="element-739">
          <ResponsiveContainer width="100%" height="100%" data-id="element-740">
            <BarChart data={supplierPerformanceData} layout="vertical" margin={{
            left: 20
          }} data-id="element-741">
              <CartesianGrid strokeDasharray="3 3" horizontal={false} data-id="element-742" />
              <XAxis type="number" domain={[0, 100]} hide data-id="element-743" />
              <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} width={100} tick={{
              fill: '#1B2A4A',
              fontWeight: 500
            }} data-id="element-744" />
              <Tooltip cursor={{
              fill: 'transparent'
            }} data-id="element-745" />
              <Legend data-id="element-746" />
              <Bar dataKey="score" name="Score de Preço" fill="#1B2A4A" radius={[0, 4, 4, 0]} barSize={20} data-id="element-747" />
              <Bar dataKey="delivery" name="Confiabilidade" fill="#94a3b8" radius={[0, 4, 4, 0]} barSize={20} data-id="element-748" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </motion.div>;
}